import { mutate } from "swr";

export function editSale(franchiseID: any, updatedRows: any, setIsAddSaleSupportClicked: Function,
    setDataIsUpdated: Function, dataIsUpdated: boolean | number) {
    const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/data`;
    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            franchiseId: franchiseID,
            types: ["saleMode"],
            data: updatedRows,
        }),
    };
    try {
        mutate(
            apiUrl,
            fetch(apiUrl, requestOptions)
                .then((response) => response.json())
                .then((data) => {
                    if (data.error) {
                        throw Error("error");
                    } else {
                        setDataIsUpdated(!dataIsUpdated);
                        setIsAddSaleSupportClicked(false);

                    }
                })
        );
    } catch (e) { }
};